type Entry = { until: number; promise: Promise<unknown> };
const reads = new Map<string, Entry>();

/** Public, recipient-independent reads survive hydration remounts, not writes. */
export function readPublicReviews<T>(key: string, load: () => Promise<T>): Promise<T> {
  const entry = reads.get(key);
  if (entry && entry.until > Date.now()) return entry.promise as Promise<T>;
  if (reads.size >= 128) reads.delete(reads.keys().next().value!);
  const promise = load();
  reads.set(key, { until: Date.now() + 5 * 60_000, promise });
  void promise.catch(() => {
    if (reads.get(key)?.promise === promise) reads.delete(key);
  });
  return promise;
}

export function invalidatePublicReviews(): void { reads.clear(); }
